export const SORTED_FILTER_ATTRIBUTE_CODES = [
  'manufacturer',
  'color',
  'bestseller',
  'new',
  'price',
  'purpose',
  'korzysci_stosowania',
  'Regeneracja_upraw',
  'aktywacja_upraw',
  'Budowanie_plonu_i_jakosci',
  'zwiekszanie_odpornosci_upraw',
  'forma_pakowania',
  'forma_transportu',
];
